import getSubscription from './getSubscription';

export default function unsubscribeUserFromPush() {
    return getSubscription().then(pushSubscription => {
        if (!pushSubscription) throw new Error('No Push Subscription found');

        return pushSubscription.unsubscribe();
    });
}
